var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCircleSinbun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_relation_news",
    transform: "translate(0.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_32",
    "data-name": "\\u6955\\u5186\\u5F62 32",
    transform: "translate(-0.134)",
    fill: "#fff",
    stroke: "#1c4ec1",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_190",
    "data-name": "\\u30D1\\u30B9 190",
    d: "M2.444,21.993a2.358,2.358,0,0,1-1.726-.717A2.358,2.358,0,0,1,0,19.549V0L2.047,2.047,4.063,0,6.109,2.047,8.156,0l2.016,2.047L12.218,0l2.047,2.047L16.281,0l2.047,2.047L20.374,0,22.39,2.047,24.436,0V19.549a2.449,2.449,0,0,1-2.444,2.444Zm0-2.444H11V12.218H2.444Zm11,0h8.553V17.105H13.44Zm0-4.887h8.553V12.218H13.44Zm-11-4.887H21.993V6.109H2.444Z",
    transform: "translate(16.157 17.309)",
    fill: "#1c4ec1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCircleSinbun);
export default __webpack_public_path__ + "static/media/ico_circle_sinbun.02dce0329cef9946c37264cc98d62462.svg";
export { ForwardRef as ReactComponent };